const context = require.context('../icons', false, /\.jsx$/);

const icons = {};

context.keys().forEach((file) => {
    const name = file.replace('./', '').replace('.jsx', '');
    icons[name] = context(file).default;
});

export const SmarticoIcon = ({ name, ...props }) => {
    const Icon = icons[name];
    return Icon ? <Icon {...props} /> : null;
}